import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CopilotCanvas } from "@/features/copilot";

const search = z.object({
  voice: z.coerce.boolean().optional().catch(undefined),
});

/** The Copilot full screen (the old Assistant page is absorbed: one Copilot experience, voice included). */
export const Route = createFileRoute("/_app/assistant")({
  validateSearch: search,
  head: () => ({ meta: [{ title: "Copilot · Malfak" }] }),
  component: AssistantRoute,
});

function AssistantRoute() {
  const { voice } = Route.useSearch();
  return (
    <div className="flex h-[calc(100dvh-3.5rem-64px-env(safe-area-inset-bottom))] p-2 sm:p-3 lg:h-[calc(100dvh-3.5rem)]" data-testid="copilot-page">
      <CopilotCanvas mode="page" autoVoice={!!voice} />
    </div>
  );
}
